const deepEquals = (obj1, obj2) => {
  if (obj1 === obj2)
    return true;
  if (obj1 === null || obj2 === null || typeof obj1 !== "object" || typeof obj2 !== "object") {
    return obj1 === obj2;
  }
  const isArray1 = Array.isArray(obj1);
  const isArray2 = Array.isArray(obj2);
  if (isArray1 !== isArray2)
    return false;
  const keys1 = Object.keys(obj1);
  const keys2 = Object.keys(obj2);
  if (keys1.length !== keys2.length)
    return false;
  return keys1.every((key) => {
    if (!Object.prototype.hasOwnProperty.call(obj2, key))
      return false;
    return deepEquals(
      obj1[key],
      obj2[key]
    );
  });
};
export {
  deepEquals
};
